import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "nav nav-tabs ps-5" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item d-none" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "container-fluid pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "users-tools",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "fas fa-user-cog" }, null, -1),
              _createTextVNode(" Herramientas de Usuarios ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "migration",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "fas fa-diagram-project" }, null, -1),
              _createTextVNode(" Migración ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "schedules-configuration",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fas fa-gear" }, null, -1),
              _createTextVNode(" Clases ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "profile-permissions",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fas fa-users" }, null, -1),
              _createTextVNode(" Permisos por perfil ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: "user-profiles",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fas fa-user" }, null, -1),
              _createTextVNode(" Perfiles por usuario ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_view)
      ])
    ]),
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"sys-config d-none\" data-v-2252330d><h1 data-v-2252330d>System Configuration</h1><ul data-v-2252330d><li data-v-2252330d>Bitcion Wallet que recibe pagos</li><li data-v-2252330d>Calendarizar Clases en vivo</li><li data-v-2252330d> Rangos <ul data-v-2252330d><li data-v-2252330d>Secuencia</li><li data-v-2252330d>Nombre</li><li data-v-2252330d>Requisitos</li><li data-v-2252330d>Imagen / icono</li><li data-v-2252330d>Foto de portada</li></ul></li><li data-v-2252330d>Perfiles de usuarios: Que pantallas ve cada perfil</li><li data-v-2252330d>Administrar usuarios</li><li data-v-2252330d>Imagenes de Inicio para usuarios</li></ul><ul data-v-2252330d><li data-v-2252330d> Pagos con Bitcoin <ul data-v-2252330d><li data-v-2252330d>Pago incompleto</li><li data-v-2252330d>Se vencio la cotización</li><li data-v-2252330d>Wallet cliente incorrecta</li><li data-v-2252330d>Cliente Sin Wallet</li></ul></li></ul><ul data-v-2252330d><li data-v-2252330d> Verificar ReLogin con otro usuario y más ventanas abiertas, se actualizan las otras ventanas abiertas </li><li data-v-2252330d> Permitir configuraciones por usuario: <ul data-v-2252330d><li data-v-2252330d>Formato de fecha</li><li data-v-2252330d>zona horaria</li><li data-v-2252330d>idioma</li><li data-v-2252330d>pago minimo</li><li data-v-2252330d>saldo congelado</li></ul></li></ul></div>", 1))
  ], 64))
}